import React, { useState } from 'react';
import LayoutItemContainer from '../../../../../containers/workflow/LayoutItemContainer';
import { Row, Col } from 'reactstrap';

const BSRow = (props) => {
    const { columns, breakpoint, layoutItems, workflow, ...rest } = props;
    const [display, setDisplay] = useState(true)
    return (
        <Row className='container-row'>
            {
                columns.map((column, index) => {
                    const config = { size: column.w, offset: column.x };
                    const windowWidth = window.innerWidth;
                    const oneColumnWidth = windowWidth / 12;
                    const layoutItemWidth = oneColumnWidth * column.w;
                    if (index > 0) {
                        const prevColumn = columns[index - 1];
                        config.offset = column.x - (prevColumn.x + prevColumn.w);
                    }
                    const hideOnDividerCollapse = {
                        display : props.dividerCollapse ? 'none' : 'block'
                    }
                    return <Col key={`${index}_${workflow.workflowModel}_${workflow.currentItem.id}`} 
                    md={config} className={`container-column`} style={window['dividerCollapse'] ? hideOnDividerCollapse: {}}>
                        <LayoutItemContainer
                            layoutItem={layoutItems[Number(column.i)]}
                            itemIndex={index}
                            workflow={workflow}
                            setDisplay={setDisplay}
                            layoutItemWidth={layoutItemWidth}
                            yPos={column.y}
                            { ...rest }
                        />
                    </Col>
                })
            }
        </Row>
    )
}

export default BSRow;